import { Check } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';

const free = ['AI packing lists (3 a day)', 'Visa & entry checks (3 a day)', 'Jet lag minimizer (3 a day)'];
const boost = ['Unlimited packing, visa and jet lag tips', 'Weather & health prep', 'Local destination tips', 'Currency converter and group expenses'];
const faqs = [
  ['Is OdyVoy really free?', 'Yes. A free account includes packing lists, visa & entry checks and the jet lag minimizer, up to 3 a day each. No credit card needed.'],
  ['What does a Boost Pass add?', 'Full premium access for 3, 7 or 14 days: unlimited tools plus weather, health, local tips, currency and shared expenses.'],
  ['Does a Boost Pass renew automatically?', 'No. It is a one-off payment that ends by itself. Nothing to cancel, no subscription.'],
  ['Do I need an account to buy a Boost Pass?', 'No. You can pay first and set up your account afterwards.'],
];

export const HomeFreeVsBoost = () => (
  <section id="free-vs-boost" className="home-container home-faq" aria-labelledby="free-vs-boost-title">
    <div className="home-faq-intro">
      <p className="home-eyebrow">Before you sign up</p>
      <h2 id="free-vs-boost-title" className="home-section-title">Free to start.<br /><span className="text-primary home-faq-boost-line">Boost when you need{'\u00A0'}it.</span></h2>
    </div>
    <div className="home-faq-plans">
      <div className="home-plan-grid">
        <div className="home-plan">
          <p className="home-small-label">Free account</p>
          <p className="text-2xl font-bold">€0</p>
          <ul>{free.map(f => <li key={f}><Check aria-hidden="true" className="h-4 w-4 shrink-0 text-primary" />{f}</li>)}</ul>
        </div>
        <div className="home-plan home-plan-boost">
          <p className="home-small-label">Boost Pass</p>
          <p className="text-2xl font-bold">from €2.99</p>
          <ul>{boost.map(f => <li key={f}><Check aria-hidden="true" className="h-4 w-4 shrink-0 text-primary" />{f}</li>)}</ul>
        </div>
      </div>
      <Link to="/pricing" className="home-plan-compare">Compare every plan</Link>
    </div>
    <Accordion type="single" collapsible className="w-full home-faq-accordion">
      {faqs.map(([q, a], i) => <AccordionItem key={q} value={q}><AccordionTrigger className={`text-left text-base font-semibold ${i === 0 ? 'pt-[21px]' : ''}`}>{q}</AccordionTrigger><AccordionContent className="text-base leading-7 text-foreground/80">{a}</AccordionContent></AccordionItem>)}
    </Accordion>
  </section>
);
